module.exports = __webpack_public_path__ + "media/images/winner--left-010194a6bcf462b25d72473fbc824c84.png";